import React from 'react';
import Radium from 'radium';
import Checkbox from 'material-ui/Checkbox';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import StylePropType from 'react-style-proptype';
import ListStyle from '../../ProjectList.styles';
import Styles from './ProjectListElement.styles';

class ProjectListElementCompressed extends React.Component {
  componentWillMount() {
    this.selectedCheckboxes = new Set();
  }

  render() {
    const {
      batchEdit,
      style,
      compressed,
      selected,
      name,
      description,
      date,
      size,
      index,
      image,
      onClick,
    } = this.props;

    const flexbox = {
      display: 'flex',
    };

    const imageStyle = {
      padding: '10px',
    };

    const imageFill = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
    };

    const checkbox = {
      style: {
        color: '#17E685',
        height: '100%',
      },
      icon: {
        color: '#084D2C',
      },
    };

    const selectedStyle = selected ? Styles.selectedStyle : {};

    return (
      <div
        role="row"
        tabIndex={index}
        style={[Styles.rowStyle, style, selectedStyle]}
        onClick={onClick}
      >
        {batchEdit && (
          <div style={[Styles.cellStyleCompressed, ListStyle.checkboxCell]}>
            <Checkbox
              checked={selected}
              style={Styles.checkbox.style}
              iconStyle={Styles.checkbox.icon}
              onCheck={() => this.onCheck()}
            />
          </div>
        )}
        <div style={[Styles.cellStyleCompressed, ListStyle.descriptionCell(batchEdit)]}>
          <div style={[Styles.nameStyle, Styles.nameStyleCompressed]}>
            <Dotdotdot clamp={1}>{name}</Dotdotdot>
          </div>
          <div style={Styles.descriptionStyle}>
            <Dotdotdot clamp={1}>{description}</Dotdotdot>
          </div>
        </div>
        <div style={[Styles.cellStyleCompressed, ListStyle.dateCell]}>{date}</div>
        <div style={[Styles.cellStyleCompressed]}>
          <div style={flexbox}>
            <span>{size}</span>
          </div>
        </div>
      </div>
    );
  }
}

ProjectListElementCompressed.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  batchEdit: PropTypes.bool.isRequired,
  compressed: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  style: StylePropType,
};

ProjectListElementCompressed.defaultProps = {
  style: {},
};

export default Radium(ProjectListElementCompressed);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListElement/ProjectListElementCompressed.js